import './App.css';
import VideoPlayer from "./VideoPlayer";

function App() {
  return (
    <div className="App">
      <VideoPlayer />
    </div>
  );
}

export default App;
